export default function HeroSection() {
  return (
    <section className="relative w-full h-[85vh] min-h-[600px] md:h-screen md:min-h-[700px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Wide%20panoramic%20editorial%20product%20collage%20with%20colorful%20streetwear%20fashion%20items%20evenly%20distributed%20across%20entire%2016%20by%209%20frame%20left%20side%20features%20coral%20sneakers%20and%20navy%20denim%20jacket%20center%20has%20mustard%20hoodie%20and%20olive%20pants%20right%20side%20filled%20with%20bright%20graphic%20tees%20neon%20accessories%20and%20green%20sneakers%20warm%20cream%20linen%20surface%20with%20organic%20natural%20scattering%20soft%20diffused%20window%20light%20from%20both%20sides%20clean%20modern%20lifestyle%20photography%20no%20empty%20dark%20areas%20full%20width%20balanced%20visual%20weight&width=1600&height=900&seq=hero-bg-css-v2-2026&orientation=landscape)",
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/25 to-background-50/55"></div>

      <div className="relative z-10 h-full flex flex-col justify-center">
        <div className="w-full max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="max-w-[620px]">
            <h1 className="text-[clamp(42px,5vw,68px)] leading-[1.05] tracking-[-0.02em] font-bold text-foreground-950 font-heading">
              Best CSSBuy Spreadsheet Hub for Shoes, Clothing &amp; Streetwear
            </h1>
            <p className="mt-6 text-[16px] md:text-[18px] text-foreground-600 leading-relaxed max-w-[520px]">
              Discover the most complete CSSBuy spreadsheet collection with real product lists, comparisons, and agent shopping guides for CSSBuy, Kakobuy, Superbuy, and Oopbuy.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 bg-foreground-900 text-background-50 rounded-full text-[14px] font-medium hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap"
              >
                Explore CSSBuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="#categories"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 bg-background-50/70 border border-secondary-300 text-foreground-800 rounded-full text-[14px] font-medium hover:border-foreground-400 transition-all duration-200 whitespace-nowrap"
              >
                Browse All Spreadsheets
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0">
          <div className="border-t border-background-300/50">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center gap-6 md:gap-10">
              <div className="flex items-center gap-2 text-[13px] text-foreground-500">
                <i className="ri-check-line text-accent-500 text-base w-5 h-5 flex items-center justify-center"></i>
                <span>Updated Weekly Spreadsheets</span>
              </div>
              <div className="flex items-center gap-2 text-[13px] text-foreground-500">
                <i className="ri-check-line text-accent-500 text-base w-5 h-5 flex items-center justify-center"></i>
                <span>10,000+ Verified Finds</span>
              </div>
              <div className="flex items-center gap-2 text-[13px] text-foreground-500">
                <i className="ri-check-line text-accent-500 text-base w-5 h-5 flex items-center justify-center"></i>
                <span>Multi-Agent Coverage</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}